import React, { useEffect, useMemo, useRef, useState } from "react";
import { toast } from "react-toastify";
import "./hotel-booking-ui.css";

const COUNTRIES = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo (Congo-Brazzaville)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czechia",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "DR Congo (Congo-Kinshasa)",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Holy See",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];


function HotelBooking() {
  const todayISO = new Date().toISOString().slice(0, 10);
  const tomorrowDate = new Date();
  tomorrowDate.setDate(tomorrowDate.getDate() + 1);
  const tomorrowISO = tomorrowDate.toISOString().slice(0, 10);

  const [formData, setFormData] = useState({
    stayQuery: "",
    country: "Pakistan",
    checkIn: todayISO,
    checkOut: tomorrowISO,
    persons: 2,
    rooms: 1,
    starRating: "Any",
    boardType: "Room Only",
  });
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [lastSearch, setLastSearch] = useState(null);
  const [isCountryOpen, setIsCountryOpen] = useState(false);
  const countryDropdownRef = useRef(null);

  const nights = useMemo(() => {
    const inDate = new Date(formData.checkIn);
    const outDate = new Date(formData.checkOut);
    const diff = outDate.getTime() - inDate.getTime();
    if (Number.isNaN(diff) || diff <= 0) {
      return 0;
    }
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
  }, [formData.checkIn, formData.checkOut]);

  const toDisplayDate = (isoDate) => {
    if (!isoDate) return "";
    const [year, month, day] = isoDate.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleField = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleCheckIn = (value) => {
    setFormData((prev) => {
      if (!prev.checkOut || value >= prev.checkOut) {
        const nextDate = new Date(value);
        nextDate.setDate(nextDate.getDate() + 1);
        return {
          ...prev,
          checkIn: value,
          checkOut: nextDate.toISOString().slice(0, 10),
        };
      }
      return { ...prev, checkIn: value };
    });
  };

  const handleSearch = (event) => {
    event.preventDefault();
    if (!formData.stayQuery.trim()) {
      toast.error("Please enter city or hotel name.");
      return;
    }
    if (nights <= 0) {
      toast.error("Check-out must be later than check-in.");
      return;
    }
    setLastSearch({
      ...formData,
      nights,
      checkInLabel: toDisplayDate(formData.checkIn),
      checkOutLabel: toDisplayDate(formData.checkOut),
    });
    toast.success("Search request captured.");
  };

  useEffect(() => {
    const closeCountryOnOutsideClick = (event) => {
      if (
        countryDropdownRef.current &&
        !countryDropdownRef.current.contains(event.target)
      ) {
        setIsCountryOpen(false);
      }
    };
    document.addEventListener("mousedown", closeCountryOnOutsideClick);
    return () =>
      document.removeEventListener("mousedown", closeCountryOnOutsideClick);
  }, []);

  return (
    <section className="hb-page">
      <div
        className="hb-hero"
        style={{ "--hb-hero-bg": `url(${process.env.PUBLIC_URL}/assets/img/cover1.jpg)` }}
      >
        <div className="hb-side-shape hb-side-left" />
        <div className="hb-side-shape hb-side-right" />

        <div className="hb-shell">
          <div className="hb-tabs">
            <button type="button" className="hb-tab hb-tab-active">
              <i className="fas fa-hotel" />
              <span>Hotels</span>
            </button>
            <button type="button" className="hb-tab">
              <i className="fas fa-shuttle-van" />
              <span>Transfer</span>
            </button>
            <button type="button" className="hb-tab">
              <i className="fas fa-ticket-alt" />
              <span>Activities</span>
            </button>
            <button type="button" className="hb-tab">
              <i className="fas fa-umbrella-beach" />
              <span>Packages</span>
            </button>
            <button type="button" className="hb-tab">
              <i className="fas fa-concierge-bell" />
              <span>Ticket Center</span>
            </button>
          </div>

          <form className="hb-panel" onSubmit={handleSearch}>
            <h2 className="hb-title">Where do you want to stay?</h2>

            <div className="hb-fields">
              <div className="hb-field">
                <div className="hb-field-start">
                  <i className="fas fa-bed" />
                  <input
                    type="text"
                    className="hb-input"
                    value={formData.stayQuery}
                    onChange={(event) => handleField("stayQuery", event.target.value)}
                    placeholder="Enter City/Hotel Name"
                    aria-label="City or Hotel Name"
                  />
                </div>
                <i className="fas fa-sliders-h hb-accent" />
              </div>

              <div className="hb-field-dropdown-wrapper" ref={countryDropdownRef}>
                <button
                  type="button"
                  className={`hb-field hb-country-trigger ${isCountryOpen ? "hb-country-open" : ""}`}
                  onClick={() => setIsCountryOpen((prev) => !prev)}
                  aria-expanded={isCountryOpen}
                >
                  <div className="hb-field-start">
                    <i className="far fa-flag" />
                    <span>{formData.country}</span>
                  </div>
                  <i className={`fas fa-chevron-down hb-chevron ${isCountryOpen ? "hb-chevron-up" : ""}`} />
                </button>

                {isCountryOpen && (
                  <div className="hb-country-dropdown">
                    {COUNTRIES.map((country) => (
                      <button
                        key={country}
                        type="button"
                        className={`hb-country-option ${formData.country === country ? "hb-country-option-active" : ""}`}
                        onClick={() => {
                          handleField("country", country);
                          setIsCountryOpen(false);
                        }}
                      >
                        {country}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <div className="hb-field">
                <div className="hb-date-field">
                  <i className="far fa-calendar-alt" />
                  <input
                    type="date"
                    className="hb-date-input"
                    value={formData.checkIn}
                    min={todayISO}
                    onChange={(event) => handleCheckIn(event.target.value)}
                    aria-label="Check in date"
                  />
                  <i className="far fa-moon" />
                  <span>{nights} night{nights === 1 ? "" : "s"}</span>
                  <i className="far fa-calendar-alt" />
                  <input
                    type="date"
                    className="hb-date-input"
                    value={formData.checkOut}
                    min={formData.checkIn || todayISO}
                    onChange={(event) => handleField("checkOut", event.target.value)}
                    aria-label="Check out date"
                  />
                </div>
              </div>

              <div className="hb-field">
                <div className="hb-field-start">
                  <i className="far fa-user" />
                  <div className="hb-guest-wrap">
                    <select
                      className="hb-select"
                      value={formData.persons}
                      onChange={(event) => handleField("persons", Number(event.target.value))}
                      aria-label="Persons"
                    >
                      <option value={1}>1 Person</option>
                      <option value={2}>2 Persons</option>
                      <option value={3}>3 Persons</option>
                      <option value={4}>4 Persons</option>
                      <option value={5}>5 Persons</option>
                    </select>
                    <span>,</span>
                    <select
                      className="hb-select"
                      value={formData.rooms}
                      onChange={(event) => handleField("rooms", Number(event.target.value))}
                      aria-label="Rooms"
                    >
                      <option value={1}>1 Room</option>
                      <option value={2}>2 Rooms</option>
                      <option value={3}>3 Rooms</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {showAdvanced && (
              <div className="hb-advanced-panel">
                <div className="hb-advanced-item">
                  <label htmlFor="hb-star">Star Rating</label>
                  <select
                    id="hb-star"
                    className="hb-select"
                    value={formData.starRating}
                    onChange={(event) => handleField("starRating", event.target.value)}
                  >
                    <option>Any</option>
                    <option>3 Star</option>
                    <option>4 Star</option>
                    <option>5 Star</option>
                  </select>
                </div>
                <div className="hb-advanced-item">
                  <label htmlFor="hb-board">Board Type</label>
                  <select
                    id="hb-board"
                    className="hb-select"
                    value={formData.boardType}
                    onChange={(event) => handleField("boardType", event.target.value)}
                  >
                    <option>Room Only</option>
                    <option>Bed & Breakfast</option>
                    <option>Half Board</option>
                    <option>Full Board</option>
                  </select>
                </div>
              </div>
            )}

            <div className="hb-bottom-row">
              <button
                type="button"
                className="hb-advanced"
                onClick={() => setShowAdvanced((prev) => !prev)}
              >
                Advanced Options <i className="fas fa-chevron-down" />
              </button>
              <button type="submit" className="hb-search">
                <i className="fas fa-search" />
                <span>Search Stays</span>
              </button>
            </div>
          </form>

          {lastSearch && (
            <div className="hb-search-summary">
              <strong>Last Search:</strong> {lastSearch.stayQuery} in {lastSearch.country},
              {" "}{lastSearch.checkInLabel} to {lastSearch.checkOutLabel} ({lastSearch.nights} nights),
              {" "}{lastSearch.persons} person(s), {lastSearch.rooms} room(s), {lastSearch.starRating}.
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default HotelBooking;
